/**
 * 动态读取插件 注册到系统
 *  命名生效两个条件
 *  1： 需要配置或者用plugin命令
 *  2： 需要启用 该命名 默认安装是启用
 */

const STATIC_FILE_DATA = require('../static/store.json');

// 获取支持的命令
// const getSupportCommonds = ({ utils: { autoRequireStaticFile } }) => autoRequireStaticFile('plugin/plugin.config.json')


// 热注册命令
const hotRegisterCommond = (commonds, opts) => {
    let { program, commander, utils: { autoRequireStaticFile, action }, OPTIONS, noBuild: { appRequire } } = opts;
    const resitCommond = [];
    commonds.forEach(commond => {
        if (commond?.enable) { // 启用的时候才注册
            let fileName = commond.path;
            let commondName = commond.name;
            try {
                // 本地的时候 直接加载本地静态文件  包模式 直接加载包
                let pluginFn = commond?.type == "local" ?
                    autoRequireStaticFile(`plugin/${fileName}`)
                    : appRequire(fileName);

                const plugin = pluginFn?.start(opts);

                if (!plugin.init) return log.me('need init method export in ' + fileName)
                if (!plugin.start) return log.me('need start method export in ' + fileName)

                // 添加命令名称
                let instance = program.command(commondName)

                // 自定义部分
                plugin.init(instance, opts);

                // 默认追加--debug参数和--message参数 已经 调用执行方法
                instance.addOption(OPTIONS.debug(commander))
                    .action(action.bind(null, {
                        start: plugin.start, // 执行方法
                        commond: commondName, // 命令名称
                    }));

                instance.addOption(OPTIONS.message(commander));
                resitCommond.push(commond)
            } catch (e) {
                log.me(`regiter ${commondName} commond error,please check [${fileName}] file`, e)
            }
        }
    });
    log.md(`already  success register   ${resitCommond.length} commonds`);
    let registerCommods = resitCommond.map(c => (
        {
            commond: c.name,
            'see commond help': `appbir ${c.name} --help`,
            enable: c.enable,
            type: c.type,
            discription: c.discription
        }));
    if (process.argv.includes('--debug')) {
        log.T(registerCommods)
    }
    return registerCommods;
}


/**
 * 初始化插件命令
 */
const initPluginCommond = (opts) => {
    let {STATIC: { jsonToFile },utils: {autoRequireStaticFile }}=opts;
    // 静态资源自动生成
    jsonToFile(STATIC_FILE_DATA);
    let commonds = autoRequireStaticFile("plugin.config.json");
    // 如果命令失效 或者删除了static/store 则需要打开命令执行后再次隐藏即可
    // let commonds = [
    //     {"name":"plugin","enable":true,"type":"package","path":"app-lib-cli-plugin-plugin","discription":"插件管理命令// TODO 进行插件管理的开发 "},
    //     {"name":"git","enable":true,"type":"package","path":"app-lib-cli-plugin-git","discription":"GIT操作"},
    //     {"name":"build","enable":true,"type":"package","path":"app-lib-cli-plugin-build","discription":"构建编译"},
    //     {"name":"md","enable":true,"type":"package","path":"app-lib-cli-plugin-md","discription":"markdown编译"},
    //     {"name":"run","enable":true,"type":"package","path":"app-lib-cli-plugin-run","discription":"自定义命令"},
    //     {"name":"server","enable":true,"type":"package","path":"app-lib-cli-plugin-server","discription":"启动服务"},
    //     {"name":"init","enable":true,"type":"package","path":"app-lib-cli-plugin-init","discription":"初始工程"},
    //     {"name":"doc","enable":true,"type":"package","path":"app-lib-cli-plugin-doc","discription":"API文档"}
    // ];
    let registerCommond = hotRegisterCommond(commonds, opts);
    return { commonds, registerCommond };
}


module.exports = { initCommond: initPluginCommond }